import { render } from "./menuItemSession.vue?vue&type=template&id=6fd55bba&scoped=true"
import script from "./menuItemSession.vue?vue&type=script&lang=js"
export * from "./menuItemSession.vue?vue&type=script&lang=js"

import "./menuItemSession.vue?vue&type=style&index=0&id=6fd55bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd55bba"]])

export default __exports__